<template lang="pug">
  .widthAll
    h1.title.is-4.has-text-info(style='margin-bottom: 30px;')
      span.icon(@click="$router.go(-1)" style="cursor: pointer;")
        i.fas.fa-arrow-left
      span(style="margin-left: 20px; margin-right: 20px;") {{ SalaTitle }}
      span.icon(@click="sendNewConference" style="cursor: pointer;" v-if="puedeMeet")
        i.fas.fa-video
    form(@submit.prevent="saveData" v-if="puedeCrear")
      .field.mesageBox
        .control.has-icons-right
          input.input.is-medium(type="text" placeholder="Mensaje" v-model="objetivo.mensaje")
          span.icon.is-right.has-text-info(style="cursor: pointer; pointer-events: initial;" @click="saveData")
            i.fas.fa-paper-plane
    article.message.messageWidth(v-for="mensaje in mensajes_list" :key="mensaje.id" :class="{ isMine: mensaje.creador === myUserId }")
      .message-body
        .name.has-text-info.is-size-7 {{ userName(mensaje) }}
        .chat(v-html="mensaje.mensaje")
        .date.has-text-grey.is-size-7 {{ formatoDate(mensaje.epoch) }}

</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import _get from "lodash/get";

export default {
  name: "MessageView",

  data: () => ({
    selectedId: null,
    unsubscribe: null,
    urlMeet: /*"https://meet.jit.si/edut",*/ "https://meet2.edutech.team/edut",
    objetivo: {
      mensaje: "",
      creador: "",
      epoch: 0
    }
  }),

  beforeDestroy() {
    this.cleanAllMensaje();
    if (this.unsubscribe && typeof this.unsubscribe === "function")
      this.unsubscribe();
  },

  created() {
    if (!this.$route.params.id) this.$router.go(-1);
    this.refresh();
  },

  watch: {
    salas_sel() {
      this.refresh();
    },
    colegios_sel() {
      this.$router.go(-1);
    }
  },

  computed: {
    ...mapState(["mensajes_list", "salas_sel", "user", "colegios_sel"]),

    SalaTitle() {
      return _get(this.salas_sel, "nombre");
    },

    puedeCrear() {
      return (
        _get(this.$store.getters.userLogged, "superuser") ||
        _get(
          this.$store.getters.userLogged,
          `permisos.${_get(this.colegios_sel, "id")}.mensajes.creacion`
        )
      );
    },

    puedeMeet() {
      return (
        _get(this.$store.getters.userLogged, "superuser") ||
        _get(
          this.$store.getters.userLogged,
          `permisos.${_get(this.colegios_sel, "id")}.videoconferencia.creacion`
        )
      );
    },

    myUserId() {
      return _get(this.$store.getters.userLogged, "id");
    },

    toSave() {
      const objetivo = JSON.parse(JSON.stringify(this.objetivo));
      objetivo.creador = this.myUserId;
      return objetivo;
    }
  },

  methods: {
    ...mapActions([
      "setOneSala",
      "listMensajeSortedLive",
      "storeMensaje",
      "cleanAllMensaje"
    ]),

    sendNewConference() {
      let mom = moment();
      this.$set(
        this.objetivo,
        "mensaje",
        `<a href="${
          this.urlMeet
        }${mom.unix()}" target="_blank">Toca aquí y entra a la videoconferencia ${mom.unix()} </a>`
      );
      this.$nextTick().then(() => this.saveData());
    },

    userName(mensaje) {
      return `@${_get(mensaje, "user.name") ||
        (_get(mensaje, "user.email")
          ? _get(mensaje, "user.email").split("@")[0]
          : "Indefinido")}`;
    },
    refresh() {
      if (this.unsubscribe && typeof this.unsubscribe === "function")
        this.unsubscribe();
      this.unsubscribe = this.listMensajeSortedLive();
    },
    formatoDate(epoch) {
      const epochMoment = moment.unix(epoch);
      const texto = `${
        moment().isSame(epochMoment, "day")
          ? "hoy"
          : moment()
              .subtract(1, "day")
              .isSame(epochMoment, "day")
          ? "ayer"
          : epochMoment.format("DD-MM-YYYY")
      }`;
      return `${epochMoment.format("hh:mm a")}, ${texto}.`;
    },
    async saveData() {
      if (!this.toSave.mensaje) return;
      let action;
      const tosave = JSON.parse(JSON.stringify(this.toSave));
      tosave.epoch = moment()
        .utc()
        .unix();
      if (!this.selectedId) {
        action = this.$store.dispatch("storeMensaje", {
          data: tosave
        });
      } else {
        action = this.$store.dispatch("updateMensaje", {
          id: this.selectedId,
          data: tosave
        });
      }
      try {
        await action;
        // this.$toastr(
        //   "success",
        //   this.selectedId
        //     ? "El registro se actualizó correctamente."
        //     : "El registro se creó correctamente."
        // );
        this.refresh();
        this.cleanFields();
      } catch (error) {
        console.error(error);
        this.$toastr(
          "error",
          this.selectedId
            ? "El registro no se pudo actualizar."
            : "El registro no se pudo crear."
        );
      }
      this.selectedId = null;
      this.openModal = false;
    },
    cleanFields() {
      this.objetivo.mensaje = "";
      this.objetivo.creador = null;
      this.objetivo.epoch = false;
    },
    selectDia(numDia) {
      switch (numDia) {
        case 0:
          return "Domingo";
        case 1:
          return "Lunes";
        case 2:
          return "Martes";
        case 3:
          return "Miércoles";
        case 4:
          return "Jueves";
        case 5:
          return "Viernes";
        case 6:
          return "Sábado";
        default:
          return "Domingo";
      }
    }
  }
};
</script>

<style scoped>
.mesageBox {
  position: relative;
  width: 100%;
  left: 50%;
  /* bottom: 10px; */
  transform: translateX(-50%);
  padding: 10px;
}

.message.isMine .message-body {
  border-width: 0 4px 0 0;
}

.message.isMine {
  border-color: #f5f5f5;
  background-color: #fafafa;
}

.chat {
  margin-top: 8px;
  margin-bottom: 3px;
  font-family: sans-serif;
}

.message.isMine .name,
.message.isMine .chat,
.message.isMine .date {
  text-align: right;
}

.message.isMine .name {
  display: none;
}

@media screen and (min-width: 999px) {
  .mesageBox {
    width: 60%;
  }
}

@media screen and (min-width: 1300px) {
  .mesageBox {
    width: 40%;
  }
}
</style>
